import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
// import { LocalStorageService } from 'angular-2-local-storage';
import * as CryptoJS from 'crypto-js';
import { jwtDecode } from 'jwt-decode';
import { environment } from '../../environments/environment';
import { DialogMessageComponent } from '../shared/components/dialogs/dialog-message/dialog-message.component';

import { HalApiCaller } from '@dxc-technology/halstack-client';
import { CommonService } from './common.service';

interface GroupSalesUserProfile {
  groupProfileId: string;
  userId: string;
  userName: string;
  lob: string;
  personaLabel: string;
  extendedData: any[];
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  dialog = inject(MatDialog);
  private http = inject(HttpClient);
  private commonService = inject(CommonService);
  userProfile;
  tokenInfo: any;
  public signedIn: boolean;
  accessToken;
  authorizationCode;
  header: any;
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_PREMISES = environment.ON_PREMISES;
  ON_CLOUD = environment.ON_CLOUD;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  userRoles;
  grantAccess: boolean;
  role: any;
  profiles;

  constructor() {
    this.initModuleSerivce();
  }

  initModuleSerivce() {
    this.header = this.commonService.getHeaders();
  }

  // Get Dropdown List
  async getDropDownList(userId, key) {
    let persona = sessionStorage.getItem('selected_role');
    let clientnumber = localStorage.getItem('clientNumber');
    let model = await HalApiCaller.get({
      headers: { ...this.header, username: userId, persona, clientnumber },
      url: environment.API_CONFIGURATION_SERVER_URL + '/lookup?list=' + key,
    });
    return model;
  }

  // Get Dropdown List
  async getGroupDropDownList(userId, key) {
    let persona = sessionStorage.getItem('selected_role');
    let clientnumber = localStorage.getItem('clientNumber');
    let model = await HalApiCaller.get({
      headers: { ...this.header, username: userId, persona, clientnumber },
      url: environment.API_GROUPCONFIGURATION_SERVER_URL + '/lookup?list=' + key,
    });
    return model;
  }

  //cognito login url
  redirectToLogin() {
    localStorage.setItem('token', '');
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem('isLogin', 'yes');
    const params = [
      'identity_provider=' + environment.COGNITO.identity_provider,
      'response_type=' + environment.COGNITO.response_type,
      'client_id=' + environment.COGNITO.ClientId,
      'scope=' + environment.COGNITO.scope,
      'redirect_uri=' + encodeURIComponent(environment.COGNITO.redirectUri),
    ];
    window.location.href = environment.COGNITO.LoginUrl + '?' + params.join('&');
  }

  //CustomIDP login url
  customIDPToLogin() {
    sessionStorage.setItem('isLogin', 'yes');
    window.location.href = environment.ON_CUSTOMIDP_Auth.LoginUrl;
  }

  // CAS login URL
  redirectToCASLogin() {}

  private strRandom(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  // CAS_Login
  CAS_LoginPage() {
    const state = this.strRandom(40);
    const codeVerifier = this.strRandom(128);
    localStorage.setItem('codeVerifier', codeVerifier);
    // this.storage.set('state', state);
    // this.storage.set('codeVerifier', codeVerifier);

    const codeVerifierHash = CryptoJS.SHA256(codeVerifier).toString(CryptoJS.enc.Base64);

    const codeChallenge = codeVerifierHash.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');

    const params = [
      'response_type=code',
      'state=' + state,
      'client_id=' + environment.OAUTH2_CAS.ClientId,
      'scope=openid',
      'code_challenge=' + codeChallenge,
      'code_challenge_method=S256',
      'redirect_uri=' + encodeURIComponent(environment.OAUTH2_CAS.CallbackUrl),
    ];
    localStorage.setItem('access_token', '');
    sessionStorage.setItem('isLogin', 'yes');
    window.location.href = environment.OAUTH2_CAS.LoginUrl + '?' + params.join('&');
  }
  //get Token CAS
  async getToken_CAS(code: string) {
    const payload = new HttpParams()
      .append('grant_type', 'authorization_code')
      .append('scope', 'openid')
      .append('client_id', environment.OAUTH2_CAS.ClientId)
      .append('code_verifier', localStorage.getItem('codeVerifier'))
      .append('redirect_uri', environment.OAUTH2_CAS.CallbackUrl)
      .append('code', code);
    let tokenInfo: any = this.http
      .post<any>(environment.OAUTH2_CAS.TokenUrl, payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .toPromise()
      .then(
        (data) => {
          return data;
        },
        (error) => {
          return { error: error };
        }
      );
    return tokenInfo;
  }
  //get access token
  async getAccessToken(authorizationCode: string) {
    let headers: any = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    let urlToken = environment.COGNITO.TokenUrl;
    let payload = new HttpParams()
      .append('grant_type', 'authorization_code')
      .append('client_id', environment.COGNITO.ClientId)
      .append('code', authorizationCode)
      .append('redirect_uri', environment.COGNITO.redirectUri);
    let response: any = await this.http
      .post<any>(urlToken, payload, { headers })
      .toPromise()
      .then(
        (data) => {
          return data;
        },
        (error) => {
          return { error: error };
        }
      );

    if (!response || (response && response.hasOwnProperty('error')) || response.hasOwnProperty('errors')) {
      localStorage.setItem('access_token', '');
      const dialogRef = this.dialog.open(DialogMessageComponent, {
        // width: '50%',
        position: {
          top: '200px',
        },
        data: {
          msg: [{ fieldName: '', message: 'accessTokenNotFound' }],
          type: 'error',
          class: 'wider',
        },
      });
      dialogRef.afterClosed().subscribe(async (result) => {
        this.redirectToLogin();
      });

      return '';
    } else {
      let ac = response.access_token;
      let id_token = response.id_token;
      sessionStorage.setItem('userToken', id_token);
      localStorage.setItem('access_token', ac);
      this.accessToken = ac;
      sessionStorage.setItem('isLogin', 'yes');
      return this.accessToken;
    }
  }

  // For Sign-up New Account
  async createNewAccount(userId, details) {
    let persona = sessionStorage.getItem('selected_role');
    let clientnumber = localStorage.getItem('clientNumber');
    let resopnse = await HalApiCaller.post({
      headers: { ...this.header, username: userId, persona, clientnumber },
      url: environment.API_USERROLE_SERVER_URL + '/users/sign-up',
      body: details,
    });
    return resopnse;
  }
  // End For Sign-up New Account

  // For Reset Password
  async resetPassword(userId, body) {
    try {
      let persona = sessionStorage.getItem('selected_role');
      let clientnumber = localStorage.getItem('clientNumber');
      let response = await HalApiCaller.patch({
        headers: { ...this.header, username: userId, persona, clientnumber },
        url: environment.API_USERROLE_SERVER_URL + '/users/pwd',
        body,
      });
      return response;
    } catch (error) {
      return error.response;
    }
  }
  // End For Reset Password

  // For Change Password
  async getDetailUserName(userName) {
    let persona = sessionStorage.getItem('selected_role');
    let clientnumber = localStorage.getItem('clientNumber');
    this.header = this.getHeaders();
    let data = await HalApiCaller.get({
      headers: { ...this.header, username: userName, persona, clientnumber },
      url: environment.API_COMMON_USERROLE_SERVER_URL + `/userdata/${userName}/getUserProfile?list=userInfo,roles`,
    });
    return data.body;
  }
  async changePassword(userId, body) {
    try {
      let persona = sessionStorage.getItem('selected_role');
      let clientnumber = localStorage.getItem('clientNumber');
      let response = await HalApiCaller.patch({
        headers: { ...this.header, username: userId, persona, clientnumber },
        url: environment.API_USERROLE_SERVER_URL + '/users/change-pwd',
        body,
      });
      return response;
    } catch (error) {
      return error.response;
    }
  }
  // End For Change Password

  get_tokenInfo() {
    if (this.PROFILE == this.ON_PREMISES) {
      var token = sessionStorage.getItem('userToken');
      this.tokenInfo = jwtDecode(token);
      localStorage.setItem('access_token', token);
      localStorage.setItem('userName', this.tokenInfo.preferred_username);
      localStorage.setItem('clientNumber', this.tokenInfo.clientNumber);
      localStorage.setItem('firstName', this.tokenInfo.firstName);
      localStorage.setItem('lastName', this.tokenInfo.lastName);
    }
    // Congito environment
    else if (this.PROFILE == this.ON_CLOUD) {
      var token = sessionStorage.getItem('userToken');
      this.tokenInfo = jwtDecode(token);
      localStorage.setItem('userName', this.tokenInfo['username']);
    }
    // CAS environment
    else if (this.PROFILE == this.ON_PREMISES_CAS) {
      var token = localStorage.getItem('access_token');
      this.tokenInfo = jwtDecode(token);
    }
    return this.tokenInfo;
  }

  getHeaders() {
    let headers;
    //On Premises
    if (this.ON_PREMISES === this.PROFILE) {
      headers = {
        authorization: 'Bearer ' + localStorage.getItem('access_token'),
      };
    }
    //Cloud
    else if (this.ON_CLOUD === this.PROFILE) {
      headers = {
        authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'x-api-key': environment.COGNITO.x_api_key,
      };
    }
    //CAS
    else if (this.PROFILE === this.ON_PREMISES_CAS) {
      headers = {
        authorization: 'Bearer ' + localStorage.getItem('access_token'),
      };
    }
    //customIDP
    else if (environment.ON_CUSTOMIDP === this.PROFILE) {
      headers = {
        authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'X-Referer': 'GroupSales',
      };
    }
    return headers;
  }

  async getUserRoles(userName: string) {
    // localStorage.setItem('userName', userName);
    let persona = sessionStorage.getItem('selected_role');
    let clientnumber = localStorage.getItem('clientNumber');
    this.header = this.commonService.getHeadersWithPROFILE();
    let res = await HalApiCaller.get({
      url: environment.API_COMMON_USERROLE_SERVER_URL + '/userdata/' + `${userName}` + '/getUserProfile?list=userInfo,roles',
      headers: { ...this.header, username: userName, persona, clientnumber },
    });
    this.userRoles = res.body;
    return this.userRoles;
  }

  isAgentUser(): boolean {
    const tokenIss = localStorage.getItem('token_iss') || sessionStorage.getItem('token_iss');
    return tokenIss === 'agent';
  }

  async getGroupSalesUserProfile(userName: string) {
    const persona = sessionStorage.getItem('selected_role');
    const clientnumber = localStorage.getItem('clientNumber');
    this.header = this.commonService.getHeadersWithPROFILE();
    const res = await HalApiCaller.get({
      url: environment.API_COMMON_USERROLE_SERVER_URL + '/groupProfileDetailsForUserById?groupId=SalesForce',
      headers: { ...this.header, username: userName, persona, clientnumber },
    });
    this.userRoles = res.body;
    return this.userRoles;
  }

  async getActiveProfile(userName: string) {
    // localStorage.setItem('userName', userName);
    let persona = sessionStorage.getItem('selected_role');
    let clientnumber = localStorage.getItem('clientNumber');
    this.header = this.commonService.getHeadersWithPROFILE();
    let profile = null;
    try {
      let res = await HalApiCaller.get({
        url: environment.API_COMMON_USERROLE_SERVER_URL + `/${userName}` + '/userProfile/active?lob=N',
        headers: { ...this.header, username: userName, persona, clientnumber },
      });
      this.profiles = res.body;
      profile = this.profiles;
    } catch (error) {
      console.error(`Can not find active profile due to ${error}`);
    }
    return profile;
  }

  async exchangeAuthCodeForToken(authCode: string) {
    const url = environment.ON_CUSTOMIDP_Auth.baseUrl + '/customidp/sale/login/auth-exchange';
    const body = {
      clientId: environment.ON_CUSTOMIDP_Auth.ClientId,
      clientSecret: environment.ON_CUSTOMIDP_Auth.clientSecret,
      authCode: authCode
    };

    const tokenInfo: any = await this.http
      .post<any>(url, body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .toPromise()
      .then(
        (data) => {
          return data;
        },
        (error) => {
          return { error: error };
        }
      );

    if (!tokenInfo || (tokenInfo && tokenInfo.hasOwnProperty('error')) || tokenInfo.hasOwnProperty('errors') || tokenInfo.errorCode !== '0') {
      localStorage.setItem('access_token', '');
      const dialogRef = this.dialog.open(DialogMessageComponent, {
        position: {
          top: '200px',
        },
        data: {
          msg: [{ fieldName: '', message: 'authCodeExchangeFailed' }],
          type: 'error',
          class: 'wider',
        },
      });
      dialogRef.afterClosed().subscribe(async (result) => {
        this.customIDPToLogin();
      });
      return '';
    } else {
      return tokenInfo;
    }
  }

  async getUserInfo() {
    let headers = {
      authorization: 'Bearer ' + localStorage.getItem('userToken'),
    };
    await this.http
      .get<any>(environment.COGNITO.UserInfo, { headers })
      .toPromise()
      .then(
        (data) => {
          let identities = JSON.parse(data['identities']);
          localStorage.setItem('userName', identities[0]['userId']);
        },
        (error) => {
          return { error: error };
        }
      );
  }
}
